/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import { CurrencyFieldItemEdit } from "./edit-item";

const CurrencyFieldEdit = () => {
    const startingValue = "0.00";

    return (
        <FieldListEditWrapper startingValue={startingValue}>
            <CurrencyFieldItemEdit />
        </FieldListEditWrapper>
    );
};

export { CurrencyFieldEdit };
